'use client';

import { useState } from 'react';
import {
  AnnouncementBar,
  Header,
  Hero,
  PatientJourney,
  TrustStats,
  MarketplaceSection,
  TelemedicineSimulatorSection,
  Benefits,
  HomeCare,
  HowItWorks,
  ReferralSection,
  FAQ,
  CTASection,
  Footer,
  FloatingHelpButton,
} from './sections';
import { LocationPromptModal } from '@/components/location/LocationPromptModal';

export function LandingPageV3() {
  const [serviceType, setServiceType] = useState<'video' | 'home'>('video');

  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300 antialiased selection:bg-primary/20 selection:text-primary">
      <AnnouncementBar />
      <Header />
      <main>
        <Hero serviceType={serviceType} onServiceTypeChange={setServiceType} />
        <MarketplaceSection />
        <TelemedicineSimulatorSection />
        <PatientJourney />
        <TrustStats />
        <Benefits />
        <HomeCare />
        <HowItWorks />
        <ReferralSection />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      <FloatingHelpButton />
      <LocationPromptModal />
    </div>
  );
}
